// @flow
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { RangePicker } from '../../../components/ant/DatePicker';

import {
  Filter,
  FilterButtonsContainer,
  FilterContainer,
  FilterItem,
  OrgUnitSelect,
  Selects,
} from './../../../components';
import Field from './../../../components/card/Field';
import type { FilterChildrenParams } from './../../../components/hoc/Filter';
import { formatDateTimeToISOString } from './../../../lib/helpers';

import type { EntityStatusType, ServiceType } from './../../../lib/types';

const { ContractServiceSelect, EntityStatusSelect, ContractorSelect } = Selects;

const SpoilerContent = styled.div`
  padding: 16px;
`;

export type ContractFilterParams = {
  services?: ServiceType,
  nodeId?: number,
  contractStatus?: EntityStatusType,
  contractorId?: number,
  startDate?: string,
  endDate?: string
};

type Props = {
  filter: ContractFilterParams,
  cleanFilter: Function,
  applyFilter: Function
};

export const ContractFilter = ({ filter, cleanFilter, applyFilter }: Props) => (
  <SpoilerContent>
    <FilterContainer>
      <Filter
        cleanFilter={cleanFilter}
        applyFilter={applyFilter}
        initialValues={filter}
        additionalFilter
      >
        {({
          values,
          changeValue,
          applyFilter,
          cleanFilter,
          showAdditional,
          handleAdditional
        }: FilterChildrenParams<ContractFilterParams>) => (
          <>
            <FilterItem>
              <Field mBottomNone>
                <ContractServiceSelect
                  size="small"
                  onChange={value => changeValue('services', value)}
                  value={values.services}
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <OrgUnitSelect
                  size="small"
                  onChange={value => changeValue('nodeId', value)}
                  value={values.nodeId}
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <EntityStatusSelect
                  size="small"
                  onChange={value => changeValue('contractStatus', value)}
                  value={values.contractStatus}
                />
              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <ContractorSelect
                  size="small"
                  onChange={value => changeValue('contractorId', value)}
                  value={values.contractorId}
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker
                  size="small"
                  format="DD.MM.YYYY"
                  placeholder={['Начало', 'Конец']}
                  value={[
                    values.startDate ? moment.utc(values.startDate) : null,
                    values.endDate ? moment.utc(values.endDate) : null
                  ]}
                  onChange={(value, dateString) => {
                    const [startDate, endDate] = value;
                    const [startDateString, endDateString] = dateString;
                    changeValue(
                      'startDate',
                      formatDateTimeToISOString(startDate, startDateString)
                    );
                    changeValue(
                      'endDate',
                      formatDateTimeToISOString(endDate, endDateString)
                    );
                  }}
                />
              </Field>
            </FilterItem>

            <FilterButtonsContainer
              applyFilter={applyFilter}
              cleanFilter={cleanFilter}
              handleAdditional={handleAdditional}
              showAdditional={showAdditional}
            />
          </>
        )}
      </Filter>
    </FilterContainer>
  </SpoilerContent>
);

export default ContractFilter;
